import { Box, Button, Card, CardActions, CardContent, CardHeader, Grid, Paper, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import '../../../shared/styles/style.css';
import { workshopCardStyle, workshopCardHeaderStyle } from "../../../shared/styles/cardStyles";
import { useLocation } from "react-router-dom";
import locationContext from "../../../app/providers/location/locationContext";
import Rating from "../../../shared/components/Rating";
import { useTranslation } from "react-i18next";
// import ElectricVehicles from "./workshop_extras/ElectricVehicles";
// import VehicleListing from "./workshop_extras/VehicleListing";
import ExtraInfo from "./workshop_extras/ExtraInfo";
import ShowFullTextOnHover from "../../../shared/components/ShowFullTextOnHover";
import Reviews from "./Reviews";
import { useGetRatingsQuery } from "../../../app/store/api/workshopApi";
import { useLazyFetchDistanceQuery } from "../../../app/store/api/googleMapsApi";

export default function Workshop({ workshop }) {

    const { state: locationState } = useContext(locationContext);
    const { t } = useTranslation();
    const { isDesktop } = useWindowSize();
    const location = useLocation();
    const [fetchDistance] = useLazyFetchDistanceQuery();
    const [ distance, setDistance ] = useState(null);
    const {data:ratingsData} = useGetRatingsQuery({ workshopId: workshop?.id });
    const {ratings} = ratingsData || {};
    // If opened trhough link, then fetch distance & rating from backend
    useEffect(() => {
        if (location.pathname.includes("workshops") && locationState.location) {
            getDistance();
        }
    }, [location]);

    const getDistance = () => {
        const { lat: lat1, lng: lng1 } = locationState.location;
        const { lat: lat2, lng: lng2 } = workshop?.location;

        fetchDistance({ lat1, lng1, lat2, lng2 })
        .then((data) => {
            setDistance(data.distance);
        })
        .catch((error) => {
            console.error("Error fetching distance:", error);
        });
    }

    return (
        <Grid className="workshop-grid-item"
            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            sx={{
                padding: 0,
                marginTop: isDesktop ? '20px' : '8px !important',
            }}
        >
            <Card className="workshop-card"
                sx={{
                    ...workshopCardStyle,
                    padding: isDesktop ? undefined : '12px 16px',
                    boxShadow: "none",
                    border:"1px solid lightgrey"
                }}
            >
                {!isDesktop ? (
                    // Compact mobile/tablet layout
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.2 }}>
                                {workshop?.name}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            {/* Left side: address, rating, distance */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, paddingRight: '8px' }}>
                                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                    {workshop?.address}
                                </Typography>

                                <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '4px', gap: '8px', flexWrap: 'wrap' }}>
                                    <Rating rating={ratings}/>
                                    <Reviews workshopId={workshop.id}/>
                                    { locationState.location && (workshop?.distance || distance) && (
                                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#00C9DB' }}>
                                            • {workshop?.distance ? workshop.distance : distance} km
                                        </Typography>
                                    ) }
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ marginTop: '8px' }} onClick={(e) => e.stopPropagation()}>
                            <ExtraInfo workshop={workshop} show={true} />
                        </Box>
                    </Box>
                ) : (
                    // Desktop layout (Original)
                    <>
                        <CardHeader
                            sx={workshopCardHeaderStyle}
                            title={
                                <Typography variant="h6" component="div" className="workshop-card-header">
                                    {workshop?.name}
                                </Typography>
                            }
                            subheader={
                                <>
                                    <Box>{workshop?.address}</Box>
                                    { locationState.location && (workshop?.distance || distance) && (
                                        <Box>
                                            {t("workshop.workshopDistance")} {workshop?.distance ? workshop.distance : distance} km
                                        </Box>
                                    ) }
                                </>
                            }
                        /> 
                        <CardContent>
                            <Grid container spacing={2} className="workshop-card-content" >
                                <Grid item size={{xs: 6, sm: 6, md: 6, lg: 6}}>
                                    <Rating rating={ratings} />
                                    <Reviews workshopId={workshop.id} />
                                </Grid>
                                <Grid item size={{xs: 6, sm: 6, md: 6, lg: 6}}>
                                    {workshop?.extraDescription && workshop.extraDescription.trim() !== "" && (
                                        <ShowFullTextOnHover text={workshop.extraDescription} maxLength={60} />
                                    )}
                                </Grid>
                            </Grid>
                        </CardContent>

                        <CardContent>
                            <ExtraInfo workshop={workshop} show={true} />
                        </CardContent>
                    </>
                )}
            </Card>
        </Grid>
    );
}

// xs={12} sm={6} md={6} lg={6}